import {Acao} from "../tipos/acao";
import {
  IconAdjustments,
  IconAffiliate,
  IconArticle,
  IconBinaryTree,
  IconBinaryTree2, IconBookFilled, IconBooks, IconBuildingPlus,
  IconCalendarDollar,
  IconCubePlus,
  IconDashboard,
  IconList,
  IconListDetails,
  IconListTree,
  IconMedicalCrossCircle,
  IconReportMedical
} from "@tabler/icons-react";
import {RoleEnum} from "./enums/role-enum";

export const menu: Acao[] = [
  {
    nome: "Dashboard",
    descricao: "Mostrar dashboard",
    url: "dashboard",
    icone: IconDashboard,
    perfis: [RoleEnum.ADM]
  },
  {
    nome: "Curso",
    descricao: "Cursos da SSP",
    url: "curso",
    icone: IconBooks,
    perfis: [RoleEnum.USUARIO],
    acoes: [
      {
          nome: "Cadastrar Curso",
          descricao: "Criar Novo Curso",
          url: "cadastrar-curso",
          icone: IconBookFilled,
        perfis: [RoleEnum.COORDENADOR, RoleEnum.ADM]
      },
      {
        nome: "Inscrições",
        descricao: "Cursos com Inscrições Abertas",
        url: "inscricoes-abertas",
        icone: IconBooks,
      },
      // {
      //   nome: "Minhas incrições",
      //   descricao: "Minhas inscrições com Inscrições Abertas",
      //   url: "inscricoes",
      //   icone: IconBooks,
      // }
    ]
  },
  {
    nome: "DOD",
    descricao: "Paginas DOD",
    url: "dod",
    icone: IconBinaryTree2,
    perfis: [RoleEnum.ADM, RoleEnum.USUARIO],
    acoes: [
      {
        nome: "Cadastrar Item DOD",
        descricao: "Criar Item DOD",
        url: "cadastrarItemDemanda",
        icone: IconCubePlus,
        perfis: [RoleEnum.ASPLAN_FORCA, RoleEnum.ADM]
      },
      {
        nome: "Criar DOD",
        descricao: "Criar DOD",
        url: "nova-demanda",
        icone: IconBinaryTree,
      },
      {
        nome: "Meus DODs",
        descricao: "Meus DODs",
        url: "minhasDemandas",
        icone: IconAffiliate,
      },
      {
        nome: "Listagem DODs",
        descricao: "DODs das aplans",
        url: "listagemDodAsplan",
        icone: IconListTree,
        perfis: [RoleEnum.ASPLAN_FORCA, RoleEnum.ADM]
      },
    ]
  },
  {
    nome: "Cirast",
    descricao: "Cadastrar Novo",
    url: "cirast",
    icone: IconMedicalCrossCircle,
    perfis: [RoleEnum.ADM, RoleEnum.CADASTRAR_CONSULTA_CIRAST, RoleEnum.FINANCEIRO],
    acoes: [
      {
        nome: "Configuração Cirast",
        descricao: "Cadastrar clinica cirast",
        url: "configuracao-cirast",
        icone: IconAdjustments,
        perfis: [RoleEnum.ADM, RoleEnum.FINANCEIRO]
      },
      {
        nome: "Cadastrar clinica",
        descricao: "Cadastrar clinica cirast",
        url: "cadastrarClinicaCirast",
        icone: IconBuildingPlus,
        perfis: [RoleEnum.ADM, RoleEnum.CADASTRAR_CLINICA_CIRAST]
      },
      {
        nome: "Cadastrar consulta Cirast",
        descricao: "Cadastrar consulta cirast",
        url: "cadastrarConsultaCirast",
        icone: IconReportMedical,
        perfis: [RoleEnum.ADM, RoleEnum.CADASTRAR_CONSULTA_CIRAST]
      },
      {
        nome: "Listar consulta Cirast",
        descricao: "Listar consulta cirast",
        url: "listarConsultasCirast",
        icone: IconList,
        perfis: [RoleEnum.ADM, RoleEnum.CADASTRAR_CONSULTA_CIRAST]
      },
      {
        nome: "Listar ADM",
        descricao: "Listar consultas",
        url: "listarConsultasAdm",
        icone: IconListDetails,
        perfis: [RoleEnum.ADM]
      },
      {
        nome: "Relatório pagamento",
        descricao: "Relatório para pagamento",
        url: "relatorioPagamentoCirast",
        icone: IconCalendarDollar,
        perfis: [RoleEnum.ADM, RoleEnum.GERAR_RELATORIO_CIRAST]
      },
      {
        nome: "Tipo Atendimento",
        descricao: "Cadastrar tipo atendimento",
        url: "cadastrarAtendimentoCirast",
        icone: IconArticle,
        perfis: [RoleEnum.ADM, RoleEnum.GERAR_RELATORIO_CIRAST]
      },
    ]
  }
]
